import { createContext } from 'react';

export const PhotoTimelineContext = createContext();
